import React, { useEffect, useState } from "react";
import { Modal, Spinner } from "reactstrap";
import { useTranslation } from "react-i18next";
import { FiCamera, FiX } from "react-icons/fi";
import { addMember } from "../ApiMember";
import { applyClassToCharacters } from "../../../constants/const";
import samplePhoto from "../../shared/profile/member-sample-photo.jpg";

const MemberPhotoModal = ({ isOpen, onClose, member }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [photoSrc, setPhotoSrc] = useState(null);

  useEffect(() => {
    if (isOpen && member?.id) {
      setLoading(true);
      setPhotoSrc(null);
      addMember()
        .getMemberPhoto(member.id)
        .then((res) => {
          if (res?.data?.image) {
            setPhotoSrc("data:image/jpeg;base64," + res.data.image);
          } else {
            setPhotoSrc(samplePhoto);
          }
        })
        .catch(() => {
          setPhotoSrc(samplePhoto);
        })
        .finally(() => setLoading(false));
    }
  }, [isOpen, member?.id]);

  const memberName = member?.name;

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered size="sm" className="mr-modal">
      <div className="mr-modal-head">
        <span className="mr-icon-tile mr-tone-teal">
          <FiCamera size={20} />
        </span>
        <div style={{ flex: 1, minWidth: 0 }}>
          <h3 style={{ wordBreak: "break-word" }}>
            {memberName ? applyClassToCharacters(memberName, "ur") : t("member_photo")}
          </h3>
          {member?.registrationNumber && (
            <p className="en" style={{ fontSize: "12px", direction: "ltr" }}>
              {member.registrationNumber}
            </p>
          )}
        </div>
        <button
          type="button"
          className="mr-close"
          onClick={onClose}
          aria-label={t("common_cancel")}
        >
          <FiX size={16} />
        </button>
      </div>

      <div className="mr-photo-modal-body">
        {loading ? (
          <div className="py-5 text-center">
            <Spinner color="primary" />
          </div>
        ) : (
          <div className="mr-photo-img-wrapper">
            <img
              src={photoSrc || samplePhoto}
              alt={memberName || "Member Photo"}
              className="mr-photo-img"
            />
          </div>
        )}
      </div>

      <div className="mr-modal-foot">
        <button type="button" className="mr-btn mr-btn-ghost" onClick={onClose}>
          {t("common_cancel")}
        </button>
      </div>
    </Modal>
  );
};

export default MemberPhotoModal;
